export default __webpack_public_path__ + "media/images/cosmos-9881dbbaca310a0f36263d0786c67f77.jpg";